import moment from "moment";
import { MessageBox,Loading } from "element-ui";
import { reportG2 } from "./../services/reportG2.service";

const state = {
  month_th: ["มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน ", "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"],
  short_month: ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'],
  text_title: "",
  table_Type_service: [],
  table_Actual_average: [],
  frequency: {
    900: "คลื่นความถี่ 900 MHz",
    1800: "คลื่นความถี่ 1800 MHz",
    2100: "คลื่นความถี่ 2.1 GHz",
    'other': "คลื่นความถี่อื่น ๆ "
  },
  service_type: {
    "Voice": "ของบริการประเภทเสียง",
    "SMS": "ของบริการประเภทSMS",
    "MMS": "ของบริการประเภทMMS",
    "Internet": "ของบริการประเภทInternet",
    "": "ของบริการประเภทเสียง บริการ SMS/MMS และบริการ Internet"
  },
  headRow: {
    voice: "",
    sms: "",
    mms: "",
    internet: ""
  },
  data_table: {},
  weighting: {},
  regulator: [],
  reducer : {},
  regulate_list: [],
  show_table: false,
  loading: true,
  data_not_found: false
};
const actions = {
  async getRegulateRate({commit}, formdata){
    let result = await reportG2.getAvgRegulate('')
    if(result.status == 200){
      commit('SET_REGULATE_LIST', result.data)
    }else{
      MessageBox.confirm(result.message, 'แจ้งเตือน', {
        confirmButtonText: 'ตกลง',
        showCancelButton: false,
        type: 'warning'
      }) 
    }
  },
  async reportMonth({commit,state}, formdata){
    let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
    commit('CLEAR_TABLE',true)
    let result = await reportG2.getAllReportData(formdata)
    if(!result.data) {
      setTimeout(function(){ loadingInstance.close() }, 250);
      return commit('DATA_NOT_FOUND',true)
    }
    commit('SHOW_TABLE',true)
    commit('LOADING',true)
    let proportion = await reportG2.getProportionMobileRate()
        proportion = proportion.data[0] || null
    let regulator = state.regulate_list
        regulator = formdata.regulate ? regulator.filter(item => item.id == formdata.regulate)[0] : null
    if(regulator){ // อัตรากำกับที่ลดลง 15% จากอัตราเฉลี่ย 7 ธค. 55
      if(moment(regulator.start_date).format('DD/MM/YYYY') == '12/07/2012' && moment(regulator.end_date).format('DD/MM/YYYY') == '31/12/2019'){
        commit('SET_REDUCER', regulator)
      }else{
        commit('SET_REDUCER', false)
      }
    }
    commit('SET_REGULATOR',regulator)
    let daterange = result.data.pop()
        formdata.daterange = daterange
    let qrydata = Object.values(result.data[0])[0]
    let tmp = {
      milestone: [],
      monthdata: {},
      proportion: {},
      pointer: {},
      counter: {},
      devider: {},
      weighting: {},
    }
    for(let item of formdata.list){
      if(formdata.compare_type == 'group'){
        for(let id of JSON.parse(item.group_company_list)){
          tmp.pointer[id] = item.group_name_th
        }
      }else{
        tmp.pointer[item.id] = item.brand_name
      }
    }
    for(let date = daterange[0],end = daterange[1]; date <= end; date = moment(date).add(1,'M').format('YYYY-MM-DD')){
      let key = moment(date).format('MM-YYYY')
      tmp.milestone.push(state.short_month[moment(date).month()]+'-'+moment(date).add(543,'Y').format('YY'))
      tmp.monthdata[key] = {}
      tmp.counter[key] = {}
      tmp.devider[key] = {}
      for(let id in tmp.pointer){
        tmp.monthdata[key][id] = { Voice : {}, SMS : {}, MMS : {}, Internet : {}}
        tmp.counter[key][id] = { Voice : 0, SMS : 0, MMS : 0, Internet : 0}
      }
      tmp.weighting[key] = { Voice : 0, SMS : 0, MMS : 0, Internet : 0}
      tmp.devider[key] = { Voice : 0, SMS : 0, MMS : 0, Internet : 0}
    }
    for(let item of qrydata){ // CLASSIFY BY MONTH
      if(item.price_avg){
        tmp.monthdata[moment(item.monthly_regulate).format('MM-YYYY')][item.provider_id][item.service_type] = item.price_avg
      }else{
        let key = moment(item.monthly_regulate).format('MM-YYYY')
        tmp.monthdata[key][item.provider_id].Voice[item.promotion_type] = item.Voice
        tmp.monthdata[key][item.provider_id].SMS[item.promotion_type] = item.SMS
        tmp.monthdata[key][item.provider_id].MMS[item.promotion_type] = item.MMS
        tmp.monthdata[key][item.provider_id].Internet[item.promotion_type] = item.Internet

        tmp.counter[key][item.provider_id]['Voice'] += item.Voice_total
        tmp.counter[key][item.provider_id]['SMS'] += item.SMS_total
        tmp.counter[key][item.provider_id]['MMS'] += item.MMS_total
        tmp.counter[key][item.provider_id]['Internet'] += item.Internet_total

        tmp.devider[key]['Voice'] += item.Voice_total
        tmp.devider[key]['SMS'] += item.SMS_total
        tmp.devider[key]['MMS'] += item.MMS_total
        tmp.devider[key]['Internet'] += item.Internet_total
      }
    }
    for(let month in tmp.monthdata){ // SET PROPORTION
      tmp.proportion[month] = {}
      for(let p_id in tmp.monthdata[month]){
        let p_name = tmp.pointer[p_id]
        tmp.proportion[month][p_name] = tmp.proportion[month][p_name] ? tmp.proportion[month][p_name] : {}
        tmp.counter[month][p_name] = tmp.counter[month][p_name] ? tmp.counter[month][p_name] : {}
        for(let service in tmp.monthdata[month][p_id]){
          tmp.proportion[month][p_name][service] = tmp.proportion[month][p_name][service] ? tmp.proportion[month][p_name][service] : []
          tmp.counter[month][p_name][service] = (tmp.counter[month][p_name][service] || 0 ) + tmp.counter[month][p_id][service]
          let item = tmp.monthdata[month][p_id][service]
          if(item.main){
            item['on-top'] > 0 
              ? tmp.proportion[month][p_name][service].push((item.main*proportion.proportion_main_promotion*0.01)+(item['on-top']*proportion.proportion_ontop_promotion*0.01))
              : tmp.proportion[month][p_name][service].push(item.main)
          }else if(item > 0 ){
            tmp.proportion[month][p_name][service].push(item)
          }
        }
      }
    }
    for(let date = daterange[0],end = daterange[1]; date <= end; date = moment(date).add(1,'M').format('YYYY-MM-DD')){
      let month = moment(date).format('MM-YYYY')
      for(let provider in tmp.proportion[month]){
        for(let service in tmp.proportion[month][provider]){
          let item = tmp.proportion[month][provider][service]
          let avg = item.length > 1 ? eval(item.join('+'))/item.length : (item[0] || 0)
          tmp.proportion[month][provider][service] = parseFloat(avg)
          tmp.weighting[month][service] += avg*tmp.counter[month][provider][service]/tmp.devider[month][service]
        }
      }
      let title = 'อัตราเฉลี่ยเกิดขึ้นจริงเดือน'+state.month_th[moment(date).month()]+' ปี พ.ศ.'+moment(date).add(543,'Y').format('YYYY')
      tmp.proportion[title] = tmp.proportion[month]
      if(formdata.weighting && moment(date).year() > 2019){
        for(let service in tmp.weighting[month]){
          tmp.weighting[month][service] = parseFloat(tmp.weighting[month][service])
        }
        tmp.proportion[month]['ค่าบริการเฉลี่ยถ่วงน้ำหนัก'] = tmp.weighting[month]
      }
      delete tmp.proportion[month]
    }
    
    let text_title = 'ตารางแสดง'+regulator.service_name+' และอัตราค่าบริการเฉลี่ยของบริการประเภทเสียง บริการ SMS/MMS และบริการ Internet'
        text_title += formdata.type_report == 'month' ? ' เดือน'+state.month_th[moment(daterange[0]).month()]+' ปี พ.ศ. ' + moment(daterange[0]).add(543,'Y').format('YYYY')
                                                      : ' ระหว่างเดือน'+state.month_th[moment(daterange[0]).month()]+' ปี พ.ศ. ' + moment(daterange[0]).add(543,'Y').format('YYYY')
                                                      + ' ถึงเดือน'+state.month_th[moment(daterange[1]).month()]+' ปี พ.ศ. ' + moment(daterange[1]).add(543,'Y').format('YYYY')
        text_title += ' โดยจำแนกตามผู้ให้บริการโทรศัพท์เคลื่อนที่'
    commit('SET_TITLE',text_title)
    commit('SET_TABLE', tmp.proportion)
    commit('SHOW_TABLE',true)
    commit('LOADING',false)
    setTimeout(function(){ loadingInstance.close() }, 250);
  },
  async reportQuarter({commit,state}, formdata){
    let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
    commit('CLEAR_TABLE',true)
    let result = await reportG2.getAllReportData(formdata)
    if(!result.data) {
      setTimeout(function(){ loadingInstance.close() }, 250);
      return commit('DATA_NOT_FOUND',true)
    }
    commit('SHOW_TABLE',true)
    commit('LOADING',true)
    let proportion = await reportG2.getProportionMobileRate()
        proportion = proportion.data[0] || null
    let regulator = state.regulate_list
        regulator = formdata.regulate ? regulator.filter(item => item.id == formdata.regulate)[0] : null
    if(regulator){ // อัตรากำกับที่ลดลง 15% จากอัตราเฉลี่ย 7 ธค. 55
      if(moment(regulator.start_date).format('DD/MM/YYYY') == '12/07/2012' && moment(regulator.end_date).format('DD/MM/YYYY') == '31/12/2019'){
        commit('SET_REDUCER', regulator)
      }else{
        commit('SET_REDUCER', false)
      }
    }
    commit('SET_REGULATOR',regulator)
    let daterange = result.data.pop()
        formdata.daterange = daterange
    let qrydata = Object.values(result.data[0])[0]
    let tmp = {
      datedata: {},
      proportion: {},
      pointer: {},
      counter: {},
      devider: {},
      weighting: {},
    }
    for(let item of formdata.list){
      if(formdata.compare_type == 'group'){
        for(let id of JSON.parse(item.group_company_list)){
          tmp.pointer[id] = item.group_name_th
        }
      }else{
        tmp.pointer[item.id] = item.brand_name
      }
    }
    for(let date = daterange[0],end = daterange[1]; date <= end; date = moment(date).add(1,'Q').format('YYYY-MM-DD')){
      let key = moment(date).format('Q-YYYY')
      tmp.datedata[key] = {}
      tmp.counter[key] = {}
      for(let id in tmp.pointer){
        tmp.datedata[key][id] = { Voice : {}, SMS : {}, MMS : {}, Internet : {}}
        tmp.counter[key][id] = { Voice : 0, SMS : 0, MMS : 0, Internet : 0}
      }
      tmp.devider[key] = { Voice : 0, SMS : 0, MMS : 0, Internet : 0}
      tmp.weighting[key] = { Voice : 0, SMS : 0, MMS : 0, Internet : 0}
    }
    for(let item of qrydata){
      let Q = moment(item.monthly_regulate).format('Q-YYYY')
      if(item.price_avg){
        tmp.datedata[Q][item.provider_id][item.service_type]  = tmp.datedata[Q][item.provider_id][item.service_type].length > 0
                                                              ? tmp.datedata[Q][item.provider_id][item.service_type].concat([item.price_avg])
                                                              : [item.price_avg]
      }else{
        tmp.datedata[Q][item.provider_id].Voice[item.promotion_type] = item.Voice
        tmp.datedata[Q][item.provider_id].SMS[item.promotion_type] = item.SMS
        tmp.datedata[Q][item.provider_id].MMS[item.promotion_type] = item.MMS
        tmp.datedata[Q][item.provider_id].Internet[item.promotion_type] = item.Internet

        tmp.counter[Q][item.provider_id]['Voice'] += item.Voice_total
        tmp.counter[Q][item.provider_id]['SMS'] += item.SMS_total
        tmp.counter[Q][item.provider_id]['MMS'] += item.MMS_total
        tmp.counter[Q][item.provider_id]['Internet'] += item.Internet_total

        tmp.devider[Q]['Voice'] += item.Voice_total
        tmp.devider[Q]['SMS'] += item.SMS_total
        tmp.devider[Q]['MMS'] += item.MMS_total
        tmp.devider[Q]['Internet'] += item.Internet_total
      }
    }
    for(let Q in tmp.datedata){ // SET PROPORTION
      tmp.proportion[Q] = {}
      for(let provider_id in tmp.datedata[Q]){
          tmp.proportion[Q][tmp.pointer[provider_id]] = tmp.proportion[Q][tmp.pointer[provider_id]] ? tmp.proportion[Q][tmp.pointer[provider_id]] : {}
          tmp.counter[Q][tmp.pointer[provider_id]] = tmp.counter[Q][tmp.pointer[provider_id]] ? tmp.counter[Q][tmp.pointer[provider_id]] : {}
        for(let service in tmp.datedata[Q][provider_id]){
          tmp.proportion[Q][tmp.pointer[provider_id]][service] = tmp.proportion[Q][tmp.pointer[provider_id]][service] ? tmp.proportion[Q][tmp.pointer[provider_id]][service] : []
          tmp.counter[Q][tmp.pointer[provider_id]][service] = (tmp.counter[Q][tmp.pointer[provider_id]][service] || 0 ) + tmp.counter[Q][provider_id][service]
          let item = tmp.datedata[Q][provider_id][service]
          if(item.main){ // IMPORT DATA
            item['on-top'] > 0 
              ? tmp.proportion[Q][tmp.pointer[provider_id]][service].push((item.main*proportion.proportion_main_promotion*0.01)+(item['on-top']*proportion.proportion_ontop_promotion*0.01))
              : tmp.proportion[Q][tmp.pointer[provider_id]][service].push(item.main)
          }else if(item.length > 0 ){ //FIXED DATA
            tmp.proportion[Q][tmp.pointer[provider_id]][service].push(...item)
          }
        }
      }
    }
    for(let date = daterange[0],end = daterange[1]; date <= end; date = moment(date).add(1,'Q').format('YYYY-MM-DD')){
      let Q = moment(date).format('Q-YYYY')
      for(let provider in tmp.proportion[Q]){
        for(let service in tmp.proportion[Q][provider]){
          let item = tmp.proportion[Q][provider][service]
          let avg = item.length > 1 ? eval(item.join('+')) / item.length : (item[0] || 0)
          tmp.proportion[Q][provider][service] = parseFloat(avg)
          tmp.weighting[Q][service] += avg*tmp.counter[Q][provider][service] / tmp.devider[Q][service]
        }
      }
      let title = 'อัตราเฉลี่ยเกิดขึ้นจริง ณ ไตรมาสที่ '+moment(date).quarter()+' ปี พ.ศ.'+moment(date).add(543,'Y').format('YYYY')
      tmp.proportion[title] = tmp.proportion[Q]
      if(formdata.weighting && moment(date).year() > 2019){
        for(let service in tmp.weighting[Q]){
          tmp.weighting[Q][service] = parseFloat(tmp.weighting[Q][service])
        }
        tmp.proportion[Q]['ค่าบริการเฉลี่ยแบบถ่วงน้ำหนัก'] = tmp.weighting[Q]
      }
      delete tmp.proportion[Q]
    }
    
    let text_title = 'ตารางแสดง'+regulator.service_name+' และอัตราค่าบริการเฉลี่ยของบริการประเภทเสียง บริการ SMS/MMS และบริการ Internet'
        text_title += formdata.type_report == 'quarter' ? ' ในไตรมาสที่ '+moment(daterange[0]).quarter()+' ปี พ.ศ. '+moment(daterange[0]).add(543,'Y').format('YYYY')
                                                        : ' ในไตรมาสที่ '+moment(daterange[0]).quarter()+' ปี พ.ศ. '+moment(daterange[0]).add(543,'Y').format('YYYY')
                                                        +' ถึงไตรมาสที่ '+moment(daterange[1]).quarter()+' ปี พ.ศ. '+moment(daterange[1]).add(543,'Y').format('YYYY')
        text_title += ' โดยจำแนกตามผู้ให้บริการโทรศัพท์เคลื่อนที่'
    commit('SET_TITLE',text_title)
    commit('SET_TABLE', tmp.proportion)
    commit('SHOW_TABLE',true)
    commit('LOADING',false)
    setTimeout(function(){ loadingInstance.close() }, 250);
  },
  async reportYear({commit,state}, formdata){
    let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
    commit('CLEAR_TABLE',true)
    let result = await reportG2.getAllReportData(formdata)
    if(!result.data) {
      setTimeout(function(){ loadingInstance.close() }, 250);
      return commit('DATA_NOT_FOUND',true)
    }
    commit('SHOW_TABLE',true)
    commit('LOADING',true)
    let proportion = await reportG2.getProportionMobileRate()
        proportion = proportion.data[0] || null
    let regulator = state.regulate_list
        regulator = formdata.regulate ? regulator.filter(item => item.id == formdata.regulate)[0] : null
    if(regulator){ // อัตรากำกับที่ลดลง 15% จากอัตราเฉลี่ย 7 ธค. 55
      if(moment(regulator.start_date).format('DD/MM/YYYY') == '12/07/2012' && moment(regulator.end_date).format('DD/MM/YYYY') == '31/12/2019'){
        commit('SET_REDUCER', regulator)
      }else{
        commit('SET_REDUCER', false)
      }
    }
    commit('SET_REGULATOR',regulator)
    let daterange = result.data.pop()
        formdata.daterange = daterange
    let qrydata = Object.values(result.data[0])[0]
    let tmp = {
      yeardata: {},
      proportion: {},
      pointer: {},
      counter: {},
      devider: {},
      weighting: {},
    }
    for(let item of formdata.list){
      if(formdata.compare_type == 'group'){
        for(let id of JSON.parse(item.group_company_list)){
          tmp.pointer[id] = item.group_name_th
        }
      }else{
        tmp.pointer[item.id] = item.brand_name
      }
    }
    for(let date = daterange[0],end = daterange[1]; date <= end; date = moment(date).add(1,'Y').format('YYYY-MM-DD')){
      let key = moment(date).year()
      tmp.yeardata[key] = {}
      tmp.counter[key] = {}
      tmp.devider[key] = {}
      for(let id in tmp.pointer){
        tmp.yeardata[key][id] = { Voice : {}, SMS : {}, MMS : {}, Internet : {}}
        tmp.counter[key][id] = { Voice : 0, SMS : 0, MMS : 0, Internet : 0}
      }
      tmp.weighting[key] = { Voice : 0, SMS : 0, MMS : 0, Internet : 0}
      tmp.devider[key] = { Voice : 0, SMS : 0, MMS : 0, Internet : 0}
    }
    for(let item of qrydata){ // CLASSIFY BY YEAR
      if(item.price_avg){
        tmp.yeardata[moment(item.monthly_regulate).format('YYYY')][item.provider_id][item.service_type] = item.price_avg
      }else{
        let key = moment(item.monthly_regulate).format('YYYY')
        tmp.yeardata[key][item.provider_id].Voice[item.promotion_type] = item.Voice
        tmp.yeardata[key][item.provider_id].SMS[item.promotion_type] = item.SMS
        tmp.yeardata[key][item.provider_id].MMS[item.promotion_type] = item.MMS
        tmp.yeardata[key][item.provider_id].Internet[item.promotion_type] = item.Internet

        tmp.counter[key][item.provider_id]['Voice'] += item.Voice_total
        tmp.counter[key][item.provider_id]['SMS'] += item.SMS_total
        tmp.counter[key][item.provider_id]['MMS'] += item.MMS_total
        tmp.counter[key][item.provider_id]['Internet'] += item.Internet_total

        tmp.devider[key]['Voice'] += item.Voice_total
        tmp.devider[key]['SMS'] += item.SMS_total
        tmp.devider[key]['MMS'] += item.MMS_total
        tmp.devider[key]['Internet'] += item.Internet_total
      }
    }
    for(let year in tmp.yeardata){ // SET PROPORTION
      tmp.proportion[year] = {}
      for(let p_id in tmp.yeardata[year]){
        let p_name = tmp.pointer[p_id]
        tmp.proportion[year][p_name] = tmp.proportion[year][p_name] ? tmp.proportion[year][p_name] : {}
        tmp.counter[year][p_name] = tmp.counter[year][p_name] ? tmp.counter[year][p_name] : {}
        for(let service in tmp.yeardata[year][p_id]){
          tmp.proportion[year][p_name][service] = tmp.proportion[year][p_name][service] ? tmp.proportion[year][p_name][service] : []
          tmp.counter[year][p_name][service] = (tmp.counter[year][p_name][service] || 0 ) + tmp.counter[year][p_id][service]
          let item = tmp.yeardata[year][p_id][service]
          if(item.main){
            item['on-top'] > 0 
              ? tmp.proportion[year][p_name][service].push((item.main*proportion.proportion_main_promotion*0.01)+(item['on-top']*proportion.proportion_ontop_promotion*0.01))
              : tmp.proportion[year][p_name][service].push(item.main)
          }else if(item > 0 ){
            tmp.proportion[year][p_name][service].push(item)
          }
        }
      }
    }
    for(let date = daterange[0],end = daterange[1]; date <= end; date = moment(date).add(1,'Y').format('YYYY-MM-DD')){
      let year = moment(date).format('YYYY')
      for(let provider in tmp.proportion[year]){
        for(let service in tmp.proportion[year][provider]){
          let item = tmp.proportion[year][provider][service]
          let avg = item.length > 1 ? eval(item.join('+'))/item.length : (item[0] || 0)
          tmp.proportion[year][provider][service] = parseFloat(avg)
          tmp.weighting[year][service] += avg*tmp.counter[year][provider][service]/tmp.devider[year][service]
        }
      }
      let title = 'อัตราเฉลี่ยเกิดขึ้นจริงปี พ.ศ.'+moment(date).add(543,'Y').format('YYYY')
      tmp.proportion[title] = tmp.proportion[year]
      if(formdata.weighting && moment(date).year() > 2019){
        for(let service in tmp.weighting[year]){
          tmp.weighting[year][service] = parseFloat(tmp.weighting[year][service])
        }
        tmp.proportion[year]['ค่าบริการเฉลี่ยแบบถ่วงน้ำหนัก'] = tmp.weighting[year]
      }
      delete tmp.proportion[year]
    }
    
    let text_title = 'ตารางแสดง'+regulator.service_name+' และอัตราค่าบริการเฉลี่ยของบริการประเภทเสียง บริการ SMS/MMS และบริการ Internet'
        text_title += formdata.type_report == 'year' ? ' ปี พ.ศ. '+moment(daterange[0]).add(543,'Y').format('YYYY')
                                                    : ' ระหว่างปี พ.ศ. '+moment(daterange[0]).add(543,'Y').format('YYYY')+' ถึงปี พ.ศ. '+moment(daterange[1]).add(543,'Y').format('YYYY')
        text_title += ' โดยจำแนกตามผู้ให้บริการโทรศัพท์เคลื่อนที่'
    commit('SET_TITLE',text_title)
    commit('SET_TABLE', tmp.proportion)
    commit('SHOW_TABLE',true)
    commit('LOADING',false)
    setTimeout(function(){ loadingInstance.close() }, 250);
  }
};

const mutations = {
  CLEAR_TABLE(state){
    state.data_table = []
    state.show_table = false
  },
  SET_TABLE(state, data){
    state.data_table = data
  },
  SET_TITLE(state,title){
    state.text_title = title
  },
  SET_REGULATOR(state,reg){
    state.regulator.service_name = reg ? reg.service_name : null
    state.regulator.Voice = reg ? (reg.voice_service_rate.toFixed(2)) : null
    state.regulator.SMS = reg ? (reg.sms_service_rate.toFixed(2)) : null
    state.regulator.MMS = reg ? (reg.mms_service_rate.toFixed(2)) : null
    state.regulator.Internet = reg ? (reg.internet_service_rate.toFixed(2)) : null
  },
  SET_REDUCER(state, reg){
    if(reg){
      var voice = reg.voice_service_rate ? parseFloat(reg.voice_service_rate*0.85).toFixed(2) : null
      var sms = reg.sms_service_rate ? parseFloat(reg.sms_service_rate*0.85).toFixed(2) : null
      var mms = reg.mms_service_rate ? parseFloat(reg.mms_service_rate*0.85).toFixed(2) : null
      var internet = reg.internet_service_rate ? parseFloat(reg.internet_service_rate*0.85).toFixed(2) : null
      state.reducer = {
        service_name : 'อัตราที่กำกับ',
        Voice : voice,
        SMS : sms,
        MMS : mms,
        Internet : internet
      }
    }else{
      state.reducer = null
    }
  },
  SHOW_TABLE(state,status){
    state.show_table = status
  },
  LOADING(state, status){
    state.loading = status
  },
  DATA_NOT_FOUND(state, status){
    state.data_not_found = status
  },
  SET_REGULATE_LIST(state, items){
    state.regulate_list = items
  }
};

export const Report_pt = {
  namespaced: true,
  state,
  actions,
  mutations
};